import React from "react";
class MapBoundaryWaters extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section id="map-boundary-waters" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Ely,+MN&daddr=Moose+Lake+BWCA+Entry,+MN+to:Snowbank+Lake,+MN+to:Lake+One,+Ely,+MN+to:Basswood+Lake,+MN+to:Prairie+Portage,+MN+to:Ely,+MN&output=embed"
            width="100%"
            height="420"
            title="Boundary Waters Canoe Area route map">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}
export default MapBoundaryWaters;
